import { render, staticRenderFns } from "./TabsGroup.vue?vue&type=template&id=5227b5de&scoped=true"
import script from "./TabsGroup.vue?vue&type=script&lang=js"
export * from "./TabsGroup.vue?vue&type=script&lang=js"
import style0 from "./TabsGroup.vue?vue&type=style&index=0&id=5227b5de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227b5de",
  null
  
)

export default component.exports